import PropTypes from 'prop-types';
import React from 'react';
import IconDetails from './IconDetails';

Solution.propTypes = {
  solutions: PropTypes.object.isRequired,
};

function Solution({ solutions }) {
  return (
    <section>
      <div className="python-solution-container">
        <header className="build-section-heading">
          <h2 className="underlined-heading">Our solution</h2>
          <p>{solutions.heading}</p>
          <p className="python-heading-subtitle">{solutions.subHeading}</p>
        </header>
        <div className="icon-details-wrapper">
          {solutions.solutionList.map((solution) => (
            <IconDetails iconDetails={solution} key={solution.title} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solution;
